import React from 'react';
import { filterFramesByFormId } from './iframes/filters';
import { isObject } from './utilities/utils';

export const GlobalStateContext = React.createContext({});

window.updateGlobalFormState = () => {};

export function GlobalContextProvider({ formId, children }) {
  const [formState, setFormState] = React.useState(() => {
    return filterFramesByFormId(formId)
      .filter((frame) => frame !== window && isObject(frame.globalConfig) && typeof frame.getValue === 'function')
      .reduce((acc, frame) => {
        acc[frame.globalConfig.name] = frame.getValue().value;
        return acc;
      }, {});
  });

  React.useLayoutEffect(() => {
    window.updateGlobalFormState = (field, value) => {
      setFormState((prev) => ({ ...prev, [field]: value }));
    };
  }, []);

  return <GlobalStateContext.Provider value={formState}>{children}</GlobalStateContext.Provider>;
}
